/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ImoClassificationDTOForGoods { 
    id?: number;
    unCode?: string;
    _class?: string;
    packageGroup?: ImoClassificationDTOForGoods.PackageGroupEnum;
    flashPoint?: string;
    description?: string;
    masterDataStatus?: ImoClassificationDTOForGoods.MasterDataStatusEnum;
}
export namespace ImoClassificationDTOForGoods {
    export type PackageGroupEnum = 0 | 1 | 2;
    export const PackageGroupEnum = {
        NUMBER_0: 0 as PackageGroupEnum,
        NUMBER_1: 1 as PackageGroupEnum,
        NUMBER_2: 2 as PackageGroupEnum
    };
    export type MasterDataStatusEnum = 0 | 1;
    export const MasterDataStatusEnum = {
        NUMBER_0: 0 as MasterDataStatusEnum,
        NUMBER_1: 1 as MasterDataStatusEnum
    };
}